import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'

const api = '/api/expense/'
const pref = 'expense-'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data?.errors || null)
  }
}

export const Expenses = createAsyncThunk(`${pref}`, (_, thunkAPI) =>
  handleRequest(axios.get(`${api}list`), thunkAPI)
)

export const createExpense = createAsyncThunk(`${pref}create`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}store`, data), thunkAPI)
)

export const editExpense = createAsyncThunk(`${pref}edit`, (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}edit/${id}`), thunkAPI)
)

export const deleteExpense = createAsyncThunk(`${pref}delete`, (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}destroy/${id}`), thunkAPI)
)

export const createExpenseTrans = createAsyncThunk(`${pref}update-trans`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}update-transaction`, data), thunkAPI)
)

export const addSubCat = createAsyncThunk(`${pref}add-sub-cat`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}add-sub-cat`, data), thunkAPI)
)

type ExpenseState = {
  record: any
  records: any
  errors: any
}

const initialState: ExpenseState = {
  records: {data: []},
  record: {},
  errors: '',
}

export const expenseSlice = createSlice({
  name: 'expense',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: () => {},
})

export const {reset} = expenseSlice.actions
export default expenseSlice.reducer
